import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { ModalAlertComponent } from '../components/dialog/modal-alert/modal-alert.component';
import config from '../../assets/config.json';
@Injectable({
  providedIn: 'root'
})
export class UtilsServicesService {

  private menuOpenSubject = new BehaviorSubject<boolean>(false);
  public menuOpen$ = this.menuOpenSubject.asObservable();
  public role = new BehaviorSubject<any>(null);
  private configVersion!: {version: string};


  urlBase = environment.URL;

  constructor(
    private http: HttpClient,  
    private dialog: MatDialog
    ) { }
  
  

  getRole(){
    if(localStorage.getItem('role')){
      this.role.next(localStorage.getItem('role'));
    }
    return this.role.asObservable();
  }

  selectRole(role:any){
    localStorage.setItem('role', role);
    this.role.next(role);
  }

  toggleMenu() {
    this.menuOpenSubject.next(!this.menuOpenSubject.value);
  }

  getGeocoding(direccion: string){
    let direccionUri = encodeURIComponent(direccion);
    // let ciudadUri = encodeURIComponent(ciudad);
    // let regionUri = encodeURIComponent(region);
    // let comunaUri = encodeURIComponent(comuna);
    const apiKey = environment.mapboxKey; // Reemplaza 'tu_access_token' con tu token de acceso de Mapbox
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${direccionUri}.json?country=CL&limit=5&types=address&language=es&access_token=${apiKey}`;
    return this.http.get(url);
  }

  geocodingGoogle(direccion: string){
    let direccionUri = encodeURIComponent(direccion);
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${direccionUri}&region=CL&key=${environment.googleKey}&result_type=address`;
    return this.http.get(url);
  }

  rutOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57) || charCode == 45 || charCode == 75 || charCode == 107) {
        return true;
    }
    return false;
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode >57 )) {
      return false;
    }
    return true;
  }



    validarRut(rut: any ) {
    // Limpiar y verificar formato básico
    var valor = this.cleanRut(rut);
    if (valor.length < 3) return false;

    // Dividir RUT en cuerpo y dígito verificador
    var cuerpo = valor.slice(0,-1);
    var dv = valor.slice(-1).toUpperCase();

    // Calcular dígito verificador
    var suma = 0;
    var multiplo = 2;
    for (var i = cuerpo.length - 1; i >= 0; i--) {
        suma = suma + cuerpo.charAt(i) * multiplo;
        if (multiplo < 7) multiplo = multiplo + 1;
        else multiplo = 2;
    }

    var dvEsperado :any = 11 - (suma % 11);
    if (dvEsperado === 10) dvEsperado = 'K';
    if (dvEsperado === 11) dvEsperado = '0';

    // Comparar dígito verificador
    return dv === String(dvEsperado);
  }

    cleanRut(rut:any) {
    return rut.replace(/[\.\-]/g, "");
  }

  
  async openAlert(info:{type: 1|2, title: string, message: any, alert? : any ,icon: "warning" | "success" | "error" | "info" | "question"| "none" }): Promise<any> {
    const dialogRef = this.dialog.open( ModalAlertComponent ,  {
      width: '480px',
      disableClose: false,
      maxHeight: '96vh',
      data: info 
    });
    return dialogRef.afterClosed().toPromise()
    .then(
      ( resultDialog: any ) => {
        return Promise.resolve( resultDialog );
      }
    );
  }

  getExpresion( target: string ) {
    let expresion;
    switch ( target ) {
      case 'correo':
        expresion = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        break;
      case 'password':
        expresion = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_@$!%*?&])[A-Za-z\d_@$!%*?&]{8,64}$/;
        break;
      case 'mayuscula':
        expresion = /^(.*[A-Z])/;
        break;
      case 'minuscula':
        expresion = /^(.*[a-z])/;
        break;
      case 'numero':
        expresion = /^(.*[0-9])/;
        break;
      case 'simbolo':
        expresion = /^(.*[_@$!%*?&])/;
        break;
      case 'onlyNumber':
        expresion = /^[0-9]*$/;
        break;
      case 'licence':
        expresion = /^[A-Za-z0-9]+-[A-Za-z0-9]+-[A-Za-z0-9]+-[A-Za-z0-9]+-[A-Za-z0-9]+$/;
        break;
      case 'phone':
        expresion = /^\+\d{11}$/;
        break;
    }
    return expresion;
  }
  

  getVersion(){
    this.configVersion = config;
    console.log({...this.configVersion , url: this.urlBase});
    
    const headers = new HttpHeaders()
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache'); 
      
    this.http
      .get<{ version: string }>("/assets/config.json", {headers})
      .subscribe(config => {        
       if (config.version !== this.configVersion.version) {
          location.reload(); 
        }
      });
  }
  
  
}
